<template>
  <div>I am another page!</div>
</template>

<script>
export default {
    name: 'OtherPage',
}
</script>

<style>

</style>